import PostRegister from './PostRegister';

export default PostRegister;
